import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'

import { ROUTE_PATH_LIST_RENTAL_PORTAL } from '../../../constants/route'
import { useInitData } from '../../../hooks'
import { Accordion, AccordionItem } from '../../Accordion'
import {
  SubMenuAccordionButton,
  SubMenuList,
  SubMenuWrapper,
} from '../../SubMenu'
import Text from '../../Text'
import {
  QA_NAME_RENTAL_PORTAL_SUB_MENU,
  QA_NAME_RENTAL_PORTAL_SUB_MENU_SETTINGS,
} from '../RentalPortal.constants'
import {
  getHasRentalPortalSettingsSubsections,
  getIsRentalPortalSubsectionActive,
  getRentalPortalSectionSubsections,
  getRentalPortalSettingsSubsections,
  getRentalPortalSubsectionByPathname,
  getRentalPortalSubsectionLink,
  getRentalPortalViewableSubsections,
} from '../RentalPortal.utils'
import { getMockApplicantsAwaitingApprovalCount } from '../RentalPortalApplicants'

import * as styles from './RentalPortalSubMenu.module.css'

function RentalPortalSubMenu({ menuTitle, show: isVisible }) {
  const { t } = useTranslation()

  const { pathname } = useLocation()
  const navigate = useNavigate()

  const { sections } = useInitData()

  const subsections = getRentalPortalViewableSubsections(sections)

  const counts = {
    [ROUTE_PATH_LIST_RENTAL_PORTAL.applicants]:
      getMockApplicantsAwaitingApprovalCount(),
  }

  function handleClickSubsection(subsectionName) {
    navigate(getRentalPortalSubsectionLink(subsectionName))
  }

  const activeSubsection = getRentalPortalSubsectionByPathname(pathname)

  function isActiveSubsection(subsection) {
    return getIsRentalPortalSubsectionActive({ activeSubsection, subsection })
  }

  const settingsSubsections = getRentalPortalSettingsSubsections(subsections)

  return isVisible ? (
    <SubMenuWrapper
      className={styles.RentalPortalSubMenu}
      qaName={QA_NAME_RENTAL_PORTAL_SUB_MENU}
    >
      <Text className={styles.subTitle}>{menuTitle}</Text>
      <SubMenuList
        className={styles.list}
        counts={counts}
        isActive={isActiveSubsection}
        items={getRentalPortalSectionSubsections(subsections)}
        onClickItem={handleClickSubsection}
      />
      {getHasRentalPortalSettingsSubsections(settingsSubsections) ? (
        <div className={styles.settings}>
          <Accordion
            variant
            ButtonComponent={SubMenuAccordionButton}
            itemClassName={styles.settingsItem}
          >
            <AccordionItem
              accordionTitle={t('RentalPortal.SettingsTitleKey')}
              initOpen={settingsSubsections.some(isActiveSubsection)}
              qaName={QA_NAME_RENTAL_PORTAL_SUB_MENU_SETTINGS}
            >
              <SubMenuList
                className={styles.settingsList}
                isActive={isActiveSubsection}
                items={settingsSubsections}
                onClickItem={handleClickSubsection}
              />
            </AccordionItem>
          </Accordion>
        </div>
      ) : null}
    </SubMenuWrapper>
  ) : null
}

export default RentalPortalSubMenu
